const BRAND_ROOT = '/brand/v1';

export const BRAND_ASSETS = Object.freeze({
  lockup: `${BRAND_ROOT}/beyondleads-full-lockup.png`,
});

export default function BrandIdentity({
  detail = '',
  size = 'md',
  className = '',
} = {}) {
  const classes = [
    'bl-brand-identity',
    'bl-brand-identity--lockup',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      data-brand-identity="lockup"
      data-brand-size={size}
    >
      <img
        className="bl-brand-identity__lockup"
        src={BRAND_ASSETS.lockup}
        width="608"
        height="266"
        alt="BeyondLeads.ai — More than leads"
        decoding="async"
      />
      {detail && <span className="bl-brand-identity__detail">{detail}</span>}
    </div>
  );
}
